// extracted by css-extract-rspack-plugin
export default {"spaceSmall":"12px","spaceFluid":"100%","cancelSuccess":"reason-success__cancelSuccess___GMswr"};